import type { Language } from '@/shared/enums/languagesEnum'
import type { CustomMessageShowType } from '../enums/CustomMessageShowType'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { DistrictMiniEntity } from '@/features/branch/domain/entities/DistrictMiniEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { UserAppType } from '../enums/UserAppType'
import type { CustomMessageButtonRequestEntity } from './CustomMessageButtonRequestEntity'
import type { CustomMessageTranslationRequestEntity } from './CustomMessageTranslationRequestEntity'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'

export class CreateUpdateCustomMessageEntity {
  isEnabled?: boolean
  startDate?:string
  expirationDate?:string
  showType?: CustomMessageShowType
  imageUrl?: string | null
  image?: FileUploadEntity
  buttons?: Array<CustomMessageButtonRequestEntity>
  translations?: Array<CustomMessageTranslationRequestEntity> 
  users?: UserMiniEntity[] 
  languages?: Language[] 
  userAppTypes?: UserAppType[]
  regions?: RegionMiniEntity[]
  districts?: DistrictMiniEntity[]
  regionIds?: Array<number> | null;
  districtIds?: Array<number> | null;
}
